import invariant from "tiny-invariant";
import { useContext } from "react";
export default (Context) => {
    const value = useContext(Context);
    invariant(value);
    return value;
};
